module.exports = __webpack_public_path__ + "img/NewsCenterDetails4_pic7.f48f72d9.png";